<template>
    <div class="table-responsive-md ui-data-table">
        <table class="table" :class="tableData.tableClass">
            <table-head :breakpoint="mobileBreakpoint">
                <table-tr :breakpoint="mobileBreakpoint">
                    <table-th
                        :breakpoint="mobileBreakpoint"
                        v-for="(item, itemIdx) in tableData.head"
                        :key="itemIdx"
                        :class="item.thCustomClass"
                    >
                        <component
                            v-if="typeof item === 'object' && item.type === 'component'"
                            v-bind="item.config"
                            v-bind:is="item.component"
                        />
                        <span v-else-if="typeof item === 'object' && item.tooltip" class="d-flex align-items-end">
                            <span v-html="item.text" />
                            <a-icon
                                icon="Info"
                                width="18"
                                v-tooltip="item.tooltip"
                            />
                        </span>
                        <span
                            v-else-if="typeof item === 'object'"
                            v-html="item.text"
                        />
                        <span
                            v-else-if="typeof item === 'string'"
                            v-html="item"
                        />
                    </table-th>
                </table-tr>
            </table-head>

            <table-body :custom-class="tableBodyCustomClass">
                <table-tr
                    :tr-spacing="trSpacing"
                    :child-expanded="
                        tableRows[rowIdx + 1] &&
                            tableRows[rowIdx + 1].find(
                                cell => cell.type === 'expanded'
                            ) &&
                            tableRows[rowIdx + 1].find(
                                cell => cell.type === 'expanded'
                            ).show
                    "
                    :expandable="
                        !!row.filter(cell => cell.type === 'expanded')[0]
                    "
                    :expanded="
                        row.filter(cell => cell.type === 'expanded')[0] &&
                            row.filter(cell => cell.type === 'expanded')[0].show
                    "
                    :mobile-striped="mobileStriped"
                    :breakpoint="mobileBreakpoint"
                    v-for="(row, rowIdx) in tableRows"
                    :key="`row-${rowIdx}`"
                    :striped="amIStriped(row, rowIdx)"
                    :style="tableData.customRowStyle"
                    :free-space="!!row.filter(cell => cell.type === 'space')[0]"
                    :no-padding="
                        !!row.filter(cell => cell.type === 'expanded')[0] &&
                            !row.filter(cell => cell.type === 'expanded')[0]
                                .componentConfig.show
                    "
                >
                    <!-- expandable row -->
                    <template v-if="!!row.filter(cell => cell.type === 'space')[0]">
                        <table-td free-space colspan="100%" />
                    </template>
                    <template v-else-if="row.filter(cell => cell.type === 'expanded')[0]">
                        <table-td
                            class="p-0"
                            :breakpoint="mobileBreakpoint"
                            colspan="100%"
                            v-if="row.filter(cell => cell.type === 'expanded')[0].show"
                        >
                            <div
                                style="width: 100%"
                                class="px-3"
                                v-if="
                                    row.filter(
                                        cell => cell.type === 'expanded'
                                    )[0].component
                                "
                            >
                                <component
                                    v-bind:is="
                                        row.filter(
                                            cell => cell.type === 'expanded'
                                        )[0].component
                                    "
                                    v-bind="
                                        row.filter(
                                            cell => cell.type === 'expanded'
                                        )[0].componentConfig
                                    "
                                />
                            </div>
                        </table-td>
                    </template>
                    <!-- end expandable row -->
                    <template v-else>
                        <h3
                            v-if="rowTitleOnMobile"
                            class="mobile-row-header"
                            :class="mobileBreakpoint"
                        >
                            {{ rowIdx }}
                        </h3>
                        <table-td
                            :all-borders="trSpacing"
                            :style="cell.tableTdStyle"
                            :class="
                                `${tableTdClass(cell)} ${!cell ? 'empty' : ''} `
                            "
                            :breakpoint="mobileBreakpoint"
                            v-for="(cell, cellIdx) in row.filter(
                                cell => cell.type !== 'hidden'
                            )"
                            :key="`cell-${cellIdx}`"
                            :no-border-bottom="
                                !!(
                                    tableRows[rowIdx + 1] &&
                                    typeof tableRows[rowIdx + 1] === 'object' &&
                                    tableRows[rowIdx + 1].filter(
                                        cell => cell.type === 'expanded'
                                    )[0] &&
                                    tableRows[rowIdx + 1].filter(
                                        cell => cell.type === 'expanded'
                                    )[0].show
                                )
                            "
                        >
                            <span
                                :class="mobileBreakpoint"
                                class="mobile-head has-tooltip"
                                v-if="
                                    headersOnMobile &&
                                        typeof tableData.head[cellIdx] === 'object' &&
                                        !tableData.head[cellIdx].hideOnMobile &&
                                        tableData.head[cellIdx].tooltip
                                "
                            >
                                <span v-html="tableData.head[cellIdx].text" />
                                <a-icon
                                    icon="Info"
                                    width="18"
                                    v-tooltip="tableData.head[cellIdx].tooltip"
                                />
                            </span>
                            <span
                                :class="mobileBreakpoint"
                                class="mobile-head"
                                v-else-if="
                                    headersOnMobile &&
                                        typeof tableData.head[cellIdx] === 'object' &&
                                        !tableData.head[cellIdx].hideOnMobile
                                "
                                v-html="tableData.head[cellIdx].text"
                            />
                            <span
                                :class="mobileBreakpoint"
                                class="mobile-head"
                                v-else-if="headersOnMobile && typeof tableData.head[cellIdx] === 'string'"
                                v-html="tableData.head[cellIdx]"
                            />
                            <component
                                v-if="typeof cell === 'object' && cell.type === 'component'"
                                :row-id="rowIdx"
                                :cell-id="cellIdx"
                                v-bind="cell.config"
                                v-bind:is="cell.component"
                            />
                            <div
                                class="td-value"
                                v-else-if="cell.text"
                                :style="cell.style"
                                :class="cell.customClass"
                                v-html="cell.text"
                            />
                            <div
                                class="td-value"
                                v-else-if="typeof cell === 'string'"
                                v-html="cell"
                            />
                        </table-td>
                    </template>
                </table-tr>
            </table-body>
        </table>
    </div>
</template>

<script>
import {
    TableTd,
    TableTr,
    TableTh,
    TableHead,
    TableBody,
    TableCheckbox,
    SelectAllItemsTableCheckbox
} from './partials'

export default {
    components: {
        TableTd,
        TableTr,
        TableTh,
        TableHead,
        TableBody,
        SelectAllItemsTableCheckbox
    },
    props: {
        trSpacing: {
            type: Boolean,
            default: false
        },
        headersOnMobile: {
            type: Boolean,
            default: false
        },
        areAllItemsSelectedGetterName: {
            type: String,
            default: ''
        },
        selectAllItemsDispatchName: {
            type: String,
            default: ''
        },
        unSelectAllItemsDispatchName: {
            type: String,
            default: ''
        },
        itemsGetterName: {
            type: String,
            default: ''
        },
        tdCustomClass: {
            type: String,
            default: ''
        },
        tableBodyCustomClass: {
            type: String,
            default: 'bg-white'
        },
        tableName: {
            type: String,
            default: ''
        },
        tableData: {
            type: Object,
            default: () => {
                return {
                    head: [],
                    body: [],
                    customRowStyle: '',
                    tableClass: ''
                }
            }
        },
        mobileBreakpoint: {
            type: String,
            default: 'md'
        },
        selectable: {
            type: Boolean,
            default: false
        },
        selectableMode: { type: String, default: 'store' },
        rowTitleOnMobile: {
            type: Boolean,
            default: false
        },
        mobileStriped: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tableRows() {
            const rows = []
            this.tableData.body.forEach((row, rowIdx) => {
                const filteredRows = row.filter(
                    cell => cell.type !== 'expanded'
                )
                rows.push(filteredRows)

                const expandedRow = row.find(cell => cell.type === 'expanded')
                if (expandedRow) rows.push([expandedRow])
                if (
                    this.trSpacing &&
                    rowIdx !== this.tableData.body.length - 1
                ) {
                    rows.push([{ type: 'space' }])
                }
            })

            return rows
        },
        allItemsLocallySelected() {
            if (this.selectableMode !== 'locally') return
            const selected = this.tableData.body
                .map(row => row[0].config && row[0].config.checked)
                .every(state => state === true)
            return selected
        },
        allItemsSelected() {
            let allSelected = true
            this.allItems.forEach(item => {
                if (!item.checked && !item.disabled) allSelected = false
            })
            return allSelected
        },
        allItems() {
            return this.$store.getters[this.itemsGetterName]
        }
    },
    watch: {
        allItemsLocallySelected: {
            handler(val) {
                if (this.selectableMode !== 'locally') return
                if (this.tableData.head[0].config) {
                    this.tableData.head[0].config.checked = val
                }
            }
        }
    },
    beforeMount() {
        if (this.selectable) {
            this.tableData.head.unshift({
                type: 'component',
                component: SelectAllItemsTableCheckbox,
                thCustomClass: 'px-3',
                hideOnMobile: true,
                config: {
                    checked: false,
                    onChange: this.onAllItemsSelectToggle,
                    checkboxName: this.tableName + 'select-all',
                    areAllItemsSelectedGetterName: this
                        .areAllItemsSelectedGetterName,
                    selectAllItemsDispatchName: this.selectAllItemsDispatchName,
                    unSelectAllItemsDispatchName: this
                        .unSelectAllItemsDispatchName
                }
            })
            this.tableData.body.forEach(row => {
                row.unshift({
                    type: 'component',
                    component: TableCheckbox,
                    tdCustomClass: 'row-select',
                    config: {
                        checked:
                            this.selectableMode === 'locally'
                                ? false
                                : undefined,
                        itemsGetterName: this.itemsGetterName,
                        checkboxName: this.tableName,
                        row,
                        onChange: val => this.onRowSelectChange({ val, row })
                    }
                })
            })
        }
    },
    methods: {
        onAllItemsSelectToggle(val) {
            if (this.selectableMode === 'store') {
                if (val) {
                    this.$store.dispatch(this.selectAllItemsDispatchName)
                } else {
                    this.$store.dispatch(this.unSelectAllItemsDispatchName)
                }
            } else if (this.selectableMode === 'locally') {
                this.tableData.body.forEach(row => {
                    this.onRowSelectChange({ val, row })
                })
            }
        },
        onRowSelectChange({ val, row }) {
            if (this.selectableMode === 'locally') row[0].config.checked = val
            this.$emit('rowSelectChange', {
                selected: val,
                id: row.find(r => r.type === 'hidden').data.id
            })
        },
        amIStriped(row, rowIdx) {
            let striped = false
            if (rowIdx % 2 !== 0) striped = true
            if (typeof row[0] === 'object' && row[0].type === 'expanded') {
                striped = this.amIStriped(
                    this.tableRows[rowIdx - 1],
                    rowIdx - 1
                )
            } else if (rowIdx > 0) {
                striped = !this.amIStriped(
                    this.tableRows[rowIdx - 1],
                    rowIdx - 1
                )
            }
            return striped
        },

        tableTdClass(cell = {}) {
            let tdClass = ''
            if (this.headersOnMobile) tdClass += 'p-3'
            if (this.selectable) tdClass += ' select-row-enabled'

            if (this.tdCustomClass) {
                tdClass += ` ${this.tdCustomClass}`
                return tdClass
            }
            if (cell.tdCustomClass) {
                tdClass += ` ${cell.tdCustomClass}`
                return tdClass
            }
            if (cell.type === 'hidden') tdClass += ' table-hidden-td'
            if (cell.mode === 'action') tdClass += ' action-td'

            return tdClass
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

@mixin rowHeaderMixin($breakpoint) {
    @include media-breakpoint-up($breakpoint) {
        display: none;
    }
}

.mobile-row-header {
    display: block;
    &.md {
        @include rowHeaderMixin(md);
    }
    &.lg {
        @include rowHeaderMixin(lg);
    }
}

.ui-data-table {
    table.table {
        border-collapse: separate;
        border-spacing: 0;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
    .mobile-row-header {
        display: block;
        &.md {
            @include rowHeaderMixin(md);
        }
        &.lg {
            @include rowHeaderMixin(lg);
        }
    }
    .mobile-head {
        font-weight: bold;
        &.has-tooltip {
            display: flex;
            align-items: end;
        }
        &.md {
            @include media-breakpoint-up(md) {
                display: none;
            }
        }
        &.lg {
            @include media-breakpoint-up(lg) {
                display: none;
            }
        }
    }
    @include media-breakpoint-down(sm) {
        .--rwd-bold-values {
            .td-value {
                .d-flex {
                    span {
                        flex: 1;
                        &:nth-of-type(2) {
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
}
.table-hidden-td {
    display: none !important;
}
.action-td {
    .table-data {
        display: flex;
        justify-content: flex-end;
    }
}
</style>